import React from "react";
import ReactDOM from "react-dom/client";
import { Helmet } from "react-helmet";
import { parse, stringify } from "query-string";
import { BrowserRouter } from "react-router-dom";
import { QueryParamProvider } from "use-query-params";
import { Provider as ReduxProvider } from "react-redux";
import { ReactRouter6Adapter } from "use-query-params/adapters/react-router-6";

import App from "App";
import store from "app/store";
import { GlobalStyle } from "styles/global";

import "antd/dist/antd.less";

const rootElement = document.getElementById("root");
if (!rootElement) {
  throw new Error("Root element not found");
}
const root = ReactDOM.createRoot(rootElement);

root.render(
  // <React.StrictMode>
  <>
    <Helmet>
      <title>Neft Settlement | Home</title>
      <meta name="description" content="Helmet application" />
    </Helmet>
    <ReduxProvider store={store}>
      <BrowserRouter>
        <QueryParamProvider
          adapter={ReactRouter6Adapter}
          options={{
            searchStringToObject: parse,
            objectToSearchString: stringify,
          }}
        >
          <GlobalStyle />
          <App />
        </QueryParamProvider>
      </BrowserRouter>
    </ReduxProvider>
  </>,
  // </React.StrictMode>,
);
